import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center gap-1" }

import { ref, watch } from 'vue';
interface IProps {
  modelValue?: any;
  label?: string;
  disabled?: boolean;
  color?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSwich',
  props: {
    modelValue: {},
    label: {},
    disabled: { type: Boolean },
    color: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const model = ref<boolean>(false);
const emit = __emit;
const props = __props;

function toggleSwitch() {
  emit('update:modelValue', !props.modelValue);
}

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue != model.value) model.value = props.modelValue;
  }
);

watch(
  () => model.value,
  () => {
    emit('update:modelValue', model.value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: toggleSwitch,
    class: "input-wapper border-add d-flex align-center gap-2 pa-4"
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prependIcon"),
      _createTextVNode(_toDisplayString(props.label), 1)
    ]),
    _createVNode(_component_v_switch, {
      compact: "",
      flat: "",
      disabled: props.disabled,
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      color: props.color,
      inset: ""
    }, null, 8, ["disabled", "modelValue", "color"])
  ]))
}
}

})